import { Box, Container, Typography, Chip } from '@mui/material';
import { FaTools } from 'react-icons/fa';
import { motion } from 'framer-motion';
import skills from '../data/skills';
import certifications from '../data/certifications';

function SkillsSection() {
  const categories = Object.keys(skills);

  if (categories.length === 0) return null;

  const certNames = certifications?.map(c => c.title) || [];

  return (
    <Box id="skills" component="section" sx={{ py: { xs: 4, sm: 5.5, md: 7 }, background: 'transparent' }}>
      <Container maxWidth="lg">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: { xs: 2.5, md: 3.5 } }}>
            <Box sx={{ width: 3, height: 22, backgroundColor: '#C4785D', borderRadius: 2, flexShrink: 0 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <FaTools size={17} color="#877D72" />
              <Typography variant="h5" component="h2" sx={{ fontSize: { xs: '1.3rem', md: '1.4rem' }, color: '#EAE3D6', fontWeight: 600, letterSpacing: '-0.015em' }}>
                Technical Skills
              </Typography>
            </Box>
          </Box>
        </motion.div>

        {/* Skills grid */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(3, 1fr)' },
            gap: { xs: 2, md: 2.5 },
            mb: { xs: 2.5, md: 3 },
          }}>
            {categories.map((category) => (
              <Box
                key={category}
                sx={{
                  p: { xs: 2, md: 2.5 },
                  backgroundColor: '#181614',
                  borderRadius: '10px',
                  border: '1px solid rgba(234,227,214,0.08)',
                }}
              >
                <Typography sx={{
                  fontWeight: 600,
                  color: '#C4785D',
                  fontSize: '0.72rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  mb: 1.5,
                  display: 'block',
                }}>
                  {category}
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.65 }}>
                  {skills[category].map((skill) => (
                    <Chip
                      key={skill.name}
                      label={skill.name}
                      size="small"
                      sx={{
                        height: 28,
                        fontSize: { xs: '0.85rem', md: '0.88rem' },
                        fontWeight: 500,
                        backgroundColor: 'rgba(234,227,214,0.05)',
                        color: '#C4C0B8',
                        border: '1px solid rgba(234,227,214,0.09)',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(196,120,93,0.1)',
                          borderColor: 'rgba(196,120,93,0.25)',
                          color: '#D4937A',
                        },
                      }}
                    />
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        </motion.div>

        {/* Certifications — condensed footnote */}
        {certNames.length > 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Box sx={{
              pt: 2,
              borderTop: '1px solid rgba(234,227,214,0.06)',
              display: 'flex',
              gap: 0.75,
              flexWrap: 'wrap',
              alignItems: 'baseline',
            }}>
              <Typography sx={{ fontSize: '0.75rem', color: '#3D3830', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', flexShrink: 0 }}>
                Certifications
              </Typography>
              <Typography sx={{ fontSize: '0.83rem', color: '#524A42', lineHeight: 1.6 }}>
                {certNames.join(' · ')}
              </Typography>
            </Box>
          </motion.div>
        )}

      </Container>
    </Box>
  );
}

export default SkillsSection;
